<!-- Shows total distance, time and cycling scores (if any) for the given Score-object -->
<script lang="ts">
    import type {Score} from "../../../map/controls/layers/trips/dbs/Score";
    import {BicycleIcon, TripIcon, } from "@anyways-open/common-svgs";

    import type {Readable} from "svelte/store";

    export let score: Readable<Score>
    let distance, time, comfort, safety, hours, minutes: number;
    score.subscribe(s => {
        distance = s.distance;
        time = s.time;
        hours = Math.floor(time / 3600)
        minutes = Math.round((time - hours * 3600) / 60)
        comfort = s.comfort
        safety = s.safety
    })
</script>

<div class="row gx-0 pb-1 pe-0  fs-tool">
    <div class="col-6">
        <div class="d-flex">
            <div class="svg-icon-sm svg-icon-grey pe-1">
                <TripIcon />
            </div>
            <div>{Math.round(distance/10) / 100} km</div>
        </div>
    </div>
    <div class="col-6">
        <div class="d-flex">
            <div class="svg-icon-sm svg-icon-grey pe-1">
                <TripIcon />
            </div>
            <div>{`${hours}h ${minutes}m`}</div>
        </div>
    </div>
</div>

{#if safety > 0 || comfort > 0}
    <div class="row gx-0 pb-1 pe-0  fs-tool">
        <div class="col-6">
            <div class="d-flex">
                <div class="svg-icon-sm svg-icon-grey pe-1">
                    <BicycleIcon />
                </div>
                <div>{Math.round(safety*100) / 100} safety</div>
            </div>
        </div>
        <div class="col-6">
            <div class="d-flex">
                <div class="svg-icon-sm svg-icon-grey pe-1">
                    <BicycleIcon />
                </div>
                <div>{Math.round(comfort*100) / 100} comfort</div>
            </div>
        </div>
    </div>
{/if}